import { render, staticRenderFns } from "./MultipleInputFile.vue?vue&type=template&id=2a944065&"
import script from "./MultipleInputFile.vue?vue&type=script&lang=js&"
export * from "./MultipleInputFile.vue?vue&type=script&lang=js&"
import style0 from "./MultipleInputFile.vue?vue&type=style&index=0&id=2a944065&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports